import React, { createContext, useContext, useEffect, useMemo, useState } from 'react'
import { doc, onSnapshot } from 'firebase/firestore'
import { db } from '../firebase'
import { useAuth } from '../auth/AuthContext'
import {
  PREMIUM_ACCESS_DOC_PATH,
  isPremiumUser,
  normalizePremiumEntries
} from '../utils/premiumAccess'

const PremiumContext = createContext({
  isPremium: false,
  premiumLoading: true,
  premiumEntries: []
})

export const PremiumProvider = ({ children }) => {
  const { currentUser, authLoading } = useAuth()
  const [premiumEntries, setPremiumEntries] = useState([])
  const [premiumLoading, setPremiumLoading] = useState(true)
  const [premiumNow, setPremiumNow] = useState(() => new Date())

  useEffect(() => {
    if (authLoading) return undefined

    if (!currentUser) {
      setPremiumEntries([])
      setPremiumLoading(false)
      return undefined
    }

    setPremiumLoading(true)

    const unsubscribe = onSnapshot(
      doc(db, ...PREMIUM_ACCESS_DOC_PATH),
      docSnap => {
        const data = docSnap.exists() ? docSnap.data() : {}
        setPremiumEntries(normalizePremiumEntries(data.users))
        setPremiumLoading(false)
      },
      error => {
        console.error('Errore caricamento Premium:', error)
        setPremiumEntries([])
        setPremiumLoading(false)
      }
    )

    return unsubscribe
  }, [authLoading, currentUser])

  useEffect(() => {
    const intervalId = window.setInterval(() => {
      setPremiumNow(new Date())
    }, 60000)

    return () => window.clearInterval(intervalId)
  }, [])

  const isPremium = useMemo(
    () => isPremiumUser(currentUser, premiumEntries, premiumNow),
    [currentUser, premiumEntries, premiumNow]
  )

  const value = useMemo(
    () => ({
      isPremium,
      premiumLoading,
      premiumEntries
    }),
    [isPremium, premiumEntries, premiumLoading]
  )

  return (
    <PremiumContext.Provider value={value}>
      {children}
    </PremiumContext.Provider>
  )
}

export const usePremium = () => useContext(PremiumContext)
